import React, {useState, useRef, useEffect} from 'react';
import './TeamCard.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

export default function TeamCard({show_display}) 
{
    const { team, team_ready, user_id, team_members_list, num_display_columns, team_member_role, setTeamMemberRole, 
            setMainColumnDisplayType, team_card_display_refresh, setTeamCardDisplayRefresh, setActionItemListDisplay } = useCTAL();

    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_actions]     = useState('checklist'); 
    const [img_members]     = useState('users'); 
    const [img_add_members] = useState('invitation'); 
    const [img_stg]         = useState('stg'); 
    const [img_history]     = useState('history'); 
    const [img_billing]     = useState('coin'); 
    const [img_settings]    = useState('settings'); 
    const [img_info]        = useState('info'); 
    
    const [img_actions_file,     setImgActionsFile]        = useState(img_loc + img_actions     + img_sel + img_ext); 
    const [img_members_file,     setImgMembersFile]        = useState(img_loc + img_members     + img_ext); 
    const [img_add_members_file, setImgAddMembersFile]     = useState(img_loc + img_add_members + img_ext); 
    const [img_stg_file,         setImgShortTermGoalsFile] = useState(img_loc + img_stg         + img_ext); 
    const [img_history_file,     setImgHistoryFile]        = useState(img_loc + img_history     + img_ext); 
    //const [img_billing_file,     setImgBillingFile]        = useState(img_loc + img_billing     + img_ext); 
    const [img_settings_file,    setImgSettingsFile]       = useState(img_loc + img_settings    + img_ext); 
    const [img_info_file,        setImgInfoFile]           = useState(img_loc + img_info        + img_ext); 

    const [sel_icon_changed, setSelIconChanged] = useState(false); 

    const [current_display_type, setCurrentDisplayType] = useState("action-item-list"); 
        
    const [team_name_txt, setTeamNameTxt]              = useState("Team Name"); 
    const [team_member_role_txt, setTeamMemberRoleTxt] = useState("role?"); 
    const [member_txt, setMemberTxt]                   = useState("? members"); 
    const [invite_txt, setInviteTxt]                   = useState("? invites"); 
    const [join_request_txt, setJoinRequestTxt]        = useState("? join requests"); 
    const [short_term_goal_txt, setShortTermGoalText]  = useState("? goals"); 
    
    const [member_style_class, setMemberStyleClass]            = useState("card-link-normal"); 
    const [invite_style_class, setInviteStyleClass]            = useState("card-link-normal"); 
    const [join_request_style_class, setJoinRequestStyleClass] = useState("card-link-normal"); 
    const [stg_class, setSTGClass]                             = useState("card-link-normal"); 

    const initRef = useRef("");
    const initMemberRef = useRef("");
    
    const tooltipRef_actions   = useRef(null);
    const tooltipRef_members   = useRef(null);
    const tooltipRef_invite    = useRef(null);
    const tooltipRef_goals     = useRef(null);
    const tooltipRef_history   = useRef(null);
    const tooltipRef_settings  = useRef(null);
    const tooltipRef_info      = useRef(null);

    useEffect(() =>
    {
        if (!team) return;

        var team_id = team.TeamID;
        
        if (initMemberRef.id != team_id + user_id) {
            initMemberRef.id = team_id + user_id;
  
            init_team();    
        } 
    }, [team]);

    useEffect(() =>
    {
        if ((team_ready) || (team_card_display_refresh)) init_team();
        if (team_card_display_refresh) setTeamCardDisplayRefresh(false);
    }, [team_ready, team_card_display_refresh]);

    useEffect(() =>
    {
        if (sel_icon_changed) show_display(current_display_type);
    }, [current_display_type]);

    if ((initRef.id != "init-done") && (tooltipRef_actions.current))
    {
        initRef.id = "init-done";

        const tooltip_actions  = new window.bootstrap.Tooltip(tooltipRef_actions.current, { container: 'body', trigger: 'hover' });
        const tooltip_members  = new window.bootstrap.Tooltip(tooltipRef_members.current, { container: 'body', trigger: 'hover' });
        const tooltip_invite   = new window.bootstrap.Tooltip(tooltipRef_invite.current, { container: 'body', trigger: 'hover' });
        const tooltip_goals    = new window.bootstrap.Tooltip(tooltipRef_goals.current, { container: 'body', trigger: 'hover' });
        const tooltip_history  = new window.bootstrap.Tooltip(tooltipRef_history.current, { container: 'body', trigger: 'hover' });
        const tooltip_settings = new window.bootstrap.Tooltip(tooltipRef_settings.current, { container: 'body', trigger: 'hover' });
        const tooltip_info     = new window.bootstrap.Tooltip(tooltipRef_info.current, { container: 'body', trigger: 'hover' });

        return () => {
            tooltip_actions.dispose();
            tooltip_members.dispose();
            tooltip_invite.dispose();
            tooltip_goals.dispose();
            tooltip_history.dispose();
            tooltip_settings.dispose();
            tooltip_info.dispose();
        };
    }

    const init_team = () => {
        if ((!team) || (!user_id)) return;

        var team_role = "role?";

        if ((team_member_role) || (team_member_role.length <= 0)) {
            var user_membership = team_members_list.filter( item => { return (item.UserID == user_id); } );
                
            if (user_membership.length == 1) {
                setTeamMemberRole(user_membership[0].TeamRole);
                team_role = user_membership[0].TeamRole; //can't count on Team Role being immediately set
            }        
        }
        else
            team_role = team_member_role;

        var num_invitations = team.NumTeamInvitations + team.NumOutsideInvitations;

        setTeamNameTxt(team.TeamName);
        setTeamMemberRoleTxt(team_role.toLowerCase());
        setMemberTxt( (team.NumMembers == 1 ? `${team.NumMembers} member`   : `${team.NumMembers} members`)   );
        setInviteTxt( (num_invitations == 1 ? `, ${num_invitations} invite` : `, ${num_invitations} invites`) );
        setJoinRequestTxt( (team.NumUserJoinRequests == 1 ? `, ${team.NumUserJoinRequests} join request` : `, ${team.NumUserJoinRequests} join requests`) );
        setShortTermGoalText( (team.NumShortTermGoals == 1 ? `${team.NumShortTermGoals} goal` : `${team.NumShortTermGoals} goals`) );

        setMemberStyleClass ( (team.NumMembers > 0 ? "card-link-highlight" : "card-link-normal") );
        setInviteStyleClass ( (num_invitations > 0 ? "card-link-highlight" : "card-link-normal") );
        setJoinRequestStyleClass ( (team.NumUserJoinRequests > 0 ? "card-link-highlight" : "card-link-normal") );
        setSTGClass ( (team.NumShortTermGoals > 0 ? "card-link-highlight" : "card-link-normal") );
    }

    const change_display = (display_type) => {
        if (display_type == current_display_type) return; //No Change
        
        setSelIconChanged(false);
        setImgActionsFile(img_loc + img_actions        + img_ext);
        setImgMembersFile(img_loc + img_members        + img_ext);
        setImgAddMembersFile(img_loc + img_add_members + img_ext);
        setImgAddMembersFile(img_loc + img_add_members + img_ext);
        setImgShortTermGoalsFile(img_loc + img_stg     + img_ext);
        setImgHistoryFile(img_loc + img_history        + img_ext);
        //setImgBillingFile(img_loc + img_billing      + img_ext);
        setImgSettingsFile(img_loc + img_settings      + img_ext);
        setImgInfoFile(img_loc + img_info              + img_ext);

        switch (display_type)
        {
            case "action-item-list":
                setActionItemListDisplay("team-display");             
                setImgActionsFile(img_loc + img_actions     + img_sel + img_ext); 
                break;
            case "members":                  setImgMembersFile(img_loc + img_members     + img_sel + img_ext); break;
            case "add-members":           setImgAddMembersFile(img_loc + img_add_members + img_sel + img_ext); break;
            case "team-invitations":      setImgAddMembersFile(img_loc + img_add_members + img_sel + img_ext); break;
            case "short-term-goals": 
                setActionItemListDisplay("team-assigned-display");             
                setImgShortTermGoalsFile(img_loc + img_stg         + img_sel + img_ext); 
                break;
            case "team-history":             setImgHistoryFile(img_loc + img_history     + img_sel + img_ext); break;
            //case "team-billing":             setImgBillingFile(img_loc + img_billing     + img_sel + img_ext); break;
            case "team-settings":           setImgSettingsFile(img_loc + img_settings    + img_sel + img_ext); break;
            case "team-information":            setImgInfoFile(img_loc + img_info        + img_sel + img_ext); break;
        }
        
        setSelIconChanged(true);
        setCurrentDisplayType(display_type);

        //show_display(display_type);    
    } 
   
    var user_link_icon;
    if (num_display_columns < 3)
        user_link_icon = <a class="me-3" href="#"><img class="card-icon" src="./images/user.svg" alt="user-display" border="0" onClick={ () => setMainColumnDisplayType("User") }/></a>;
    else
        user_link_icon = <></>;

    return (
        <>
            <div class="card mt-2 mb-1">
                <div id="team-card-body" class="card-body">
                    <h5 class="card-title text-center">{team_name_txt} <small>({team_member_role_txt})</small></h5>
                    <div class="row">
                        <div class="col-9 text-start">
                            <small>
                                <span class={member_style_class}><a href="#" onClick={ () => change_display("members") }>{member_txt}</a></span>
                                <span class={invite_style_class}><a href="#" onClick={ () => change_display("team-invitations") }>{invite_txt}</a></span>
                                <span class={join_request_style_class}><a href="#" onClick={ () => change_display("team-invitations") }>{join_request_txt}</a></span>
                            </small>
                        </div>
                        <div class={"col-3 text-end"}>
                            <small>
                                <span class={stg_class}><a href="#" onClick={ () => change_display("short-term-goals") }>{short_term_goal_txt}</a></span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-1 text-start">
                            {user_link_icon}
                        </div>
                        <div class="col text-end">
                            <a href="#" ref={tooltipRef_actions}  data-bs-toggle="tooltip" data-bs-title="Team Actions"     data-bs-delay="750"><img class="card-icon"     src={img_actions_file}     alt="list"     border="0" onClick={ () => change_display("action-item-list") }/></a>
                            <a href="#" ref={tooltipRef_goals}    data-bs-toggle="tooltip" data-bs-title="Team Goals"       data-bs-delay="750"><img class="card-icon"     src={img_stg_file}         alt="stgs"     border="0" onClick={ () => change_display("short-term-goals") }/></a>
                            <a href="#" ref={tooltipRef_members}  data-bs-toggle="tooltip" data-bs-title="Team Members"     data-bs-delay="750"><img class="card-icon"     src={img_members_file}     alt="users"    border="0" onClick={ () => change_display("members") }/></a>
                            <a href="#" ref={tooltipRef_invite}   data-bs-toggle="tooltip" data-bs-title="Team Invitations" data-bs-delay="750"><img class="card-icon"     src={img_add_members_file} alt="invite"   border="0" onClick={ () => change_display("add-members") }/></a>
                            <a href="#" ref={tooltipRef_history}  data-bs-toggle="tooltip" data-bs-title="Team History"     data-bs-delay="750"><img class="card-icon"     src={img_history_file}     alt="history"  border="0" onClick={ () => change_display("team-history") }/></a>
                            <a href="#" ref={tooltipRef_settings} data-bs-toggle="tooltip" data-bs-title="Team Settings"    data-bs-delay="750"><img class="card-icon"     src={img_settings_file}    alt="settings" border="0" onClick={ () => change_display("team-settings") }/></a>
                            <a href="#" ref={tooltipRef_info}     data-bs-toggle="tooltip" data-bs-title="Team Information" data-bs-delay="750"><img class="card-icon-end" src={img_info_file}        alt="info"     border="0" onClick={ () => change_display("team-information") }/></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

/*
    //9/11/2023 Removed for Release v1.0
    <a href="#"><img class="card-icon"     src={img_billing_file}       alt="billing"      border="0" onClick={ () => change_display("team-billing") }/></a>

*/